import type { MagentoReplacedFrom } from "../../services/use-orders"
import { formatDateTime } from "../../lib/format-date"
import { Callout } from "../ui/callout"

export function ReplacedFromNote({
  replacedFrom,
  state,
}: {
  replacedFrom: MagentoReplacedFrom
  state: string | null
}) {
  if (state === "linked") {
    const summary =
      `The original Magento order ${replacedFrom.incrementId} (entity ${replacedFrom.entityId}) was ` +
      `${replacedFrom.status} and recreated as a replacement. Nova relinked this order to the ` +
      `replacement on ${formatDateTime(replacedFrom.relinkedAt)}, so the Magento, OMS, and tracking ` +
      `above reflect the live replacement.`
    return (
      <Callout tone="info" title="Replaced a canceled Magento order">
        <p className="mt-2 text-xs text-muted-foreground">{summary}</p>
      </Callout>
    )
  }
  const summary =
    `The original Magento order ${replacedFrom.incrementId} (entity ${replacedFrom.entityId}) was ` +
    `${replacedFrom.status}, but the exact marketplace-ID evidence is ambiguous. Nova cannot ` +
    `pick the replacement automatically. Review fresh candidates below.`
  return (
    <Callout tone="warning" title="Canceled Magento order — replacement needs manual resolution">
      <p className="mt-2 text-xs text-muted-foreground">{summary}</p>
    </Callout>
  )
}
